var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nn-icon h-6 w-6 inline-flex items-center justify-center rounded-full",class:_vm.wrapperClasses},[_c('fa-icon',_vm._b({attrs:{"icon":[_vm.type, _vm.icon]}},'fa-icon',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }